var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-top';
                    var viewUrl = 'sprite.svg#view-icon-arrow-top';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-arrow-top#icon-arrow-top';
                            viewUrl = 'sprite.svg?icon-arrow-top#view-icon-arrow-top';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 36 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };